const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/uster/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        welcomeTitle: 'Willkommen im Patientenportal Spital Uster',
        welcomeText:
            'Behalten Sie jederzeit den Überblick über Ihre Spitaltermine, wichtige Dokumente und Gesundheitsdaten – einfach, transparent und überall verfügbar. Ob Termine verwalten oder Unterlagen einsehen: Ihre Gesundheit auf einen Blick!',
        synedraCardTitle: 'Medizinische Unterlagen',
    },
    __RELATIVE_SOURCE_FILE__
);
